export default __webpack_public_path__ + "static/media/fact_sheet51.6d52c402.png";